import { faPlus, faUserGroup } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { queryString } from '@olivierpascal/helpers';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Heading } from '~/components/molecules/Heading';
import { OrganizationInvitationList } from '~/components/organisms/OrganizationInvitationList';
import { OrganizationUsersTabs } from '~/components/organisms/OrganizationUsersTabs';

export type IOrganizationInvitationsPageProps = {
  organizationId: string;
};

export const OrganizationInvitationsPage: React.FC<
  IOrganizationInvitationsPageProps
> = (props) => {
  const { organizationId } = props;
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <>
      <Helmet>
        <title>{t('OrganizationInvitationsPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faUserGroup} />}
        title={t('common.organizationUsers')}
        subtitle={t('OrganizationInvitationsPage.subtitle')}
        actions={
          <Button
            href={`/organizations/${organizationId}/invitations/create?${queryString.build(
              { cancelUrl: location.pathname },
            )}`}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            {t('OrganizationInvitationsPage.invite')}
          </Button>
        }
      />

      <OrganizationUsersTabs
        organizationId={organizationId}
        defaultAnchor="invitations"
      />
      <OrganizationInvitationList organizationId={organizationId} />
    </>
  );
};
